import { z } from 'zod';

const freeTextHintItemSchema = z.object({
  type: z.literal('free-text'),
  value: z.string().min(1),
});
export type FreeTextHintItem = z.infer<typeof freeTextHintItemSchema>;

const promptHintItemSchema = z.object({
  type: z.literal('prompt'),
  value: z.object({
    promptIdentifier: z.uuid(),
  }),
});
export type PromptHintItem = z.infer<typeof promptHintItemSchema>;

export const HintItemSchema = z.discriminatedUnion('type', [freeTextHintItemSchema, promptHintItemSchema]);
export type HintItem = z.infer<typeof HintItemSchema>;
